import { Customer } from '../models/customer';
import { Injectable } from '@angular/core';
import { VerticalSelectorService } from './vertical-selector.service';
import { environment } from 'src/environments/environment';
import { getStorageObject } from '../utils/storage-manager';
import { startWith } from 'rxjs/operators';

export enum ApiZones {
  EU,
  US
}

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  /**
   * Domain
   */
  private domain!: URL;

  /**
   * Environment interface
   */
  private environment = environment;

  /**
   * If the selected customer is University, the eurodev PROD API domain is not valid, so we use
   * it own URL
   */
  constructor(private verticalSelectorService: VerticalSelectorService) {
    this.verticalSelectorService.selectedVertical$.pipe(startWith(null)).subscribe(() => {
      if (getStorageObject('vertical')) {
        if (getStorageObject('vertical').domain == 'app') {
          this.domain = new URL(
            this.environment.apiPath,
            `${environment.apiProtocol}://${environment.universityApiDomain}`
          );
        } else {
          this.domain = new URL(
            this.environment.apiPath,
            `${environment.apiProtocol}://${getStorageObject('vertical').domain}.${
              environment.apiDomain}`
          );
        }
      } else {
        this.domain = new URL(
          this.environment.apiPath,
          `${environment.apiProtocol}://security.${
            environment.apiDomain
          }`
        );
      }
      if (this.environment.apiPort) {
        this.domain.port = this.environment.apiPort.toString(10);
      }
    });
  }

  /**
   * Get current ApiUrl taking into account the subdomain
   */
  public getApiUrl(): string {
    return this.domain.toString() + '/';
  }

  public securityApiUrl(zone: ApiZones): string {
    const securitySubDomainMapping = {
      [ApiZones.EU]: 'security',
      [ApiZones.US]: 'us_security'
    }
    const securityUrl = new URL(
      this.environment.apiPath,
      `${environment.apiProtocol}://${securitySubDomainMapping[zone]}.${
        environment.apiDomain
      }`
    );

    if(this.environment.apiPort) {
      securityUrl.port = this.environment.apiPort.toString(10);
    }

    return securityUrl.toString();
  }

  public getApiSubdomain(): string {
    const hostname = this.domain.hostname.toString();
    let subdomainPart = '';
    // Check if the hostname ends with the verticalURL
    if (hostname.endsWith(environment.verticalURL)) {
      subdomainPart = hostname.slice(0, -environment.verticalURL.length - 1);
    }
    // Check if the hostname ends with the verticalURL
    if (environment.universityURL && hostname.endsWith(environment.universityURL)) {
      subdomainPart = 'app'
    }

    return subdomainPart
  }

  public getApiHostname(): string {
    return this.domain.hostname.toString();
  }

  getVerticalURL(backofficeRedirectUrl?: string): URL {
    const domain: Customer = getStorageObject('vertical');
    const currentUrl: URL = new URL(window.location.href);
    if (domain.domain == 'university') {
      return new URL('/', `${currentUrl.protocol}//${this.environment.universityURL}`);
    }

    if (backofficeRedirectUrl) {
      return new URL('/', `${currentUrl.protocol}//${backofficeRedirectUrl}`);
    }

    return new URL('/', `${currentUrl.protocol}//${this.getApiSubdomain()}.${this.environment.verticalURL}`);
  }

  public getValidZones(): ApiZones[] {
    return Object.keys(ApiZones)
      .filter(key => isNaN(Number(key)) && this.environment.regionsAvailables.includes(key))
      .map(key => ApiZones[key as keyof typeof ApiZones]);
  }
}
